import { DesignLanguage } from "@swiggy-private/dls-web-common/dist/components/types.internal";
import React, { ReactElement } from "react";
import { useTheme } from "styled-components";

function LineIcon(): ReactElement {
    const theme = useTheme();
    const isToing = theme.designLanguage === DesignLanguage.TOING;
    return (
        <svg width="4" height="15" viewBox="0 0 4 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2 0V27"
                stroke={isToing ? theme.colors[theme.colorMode].primary : theme.colors[theme.colorMode].rain}
                strokeWidth="5"
            />
        </svg>
    );
}

export default LineIcon;
